import React from 'react';
import { Award, AlertCircle } from 'lucide-react';

/**
 * Секция для выбора профессиональной категории (отображается, если выбрана опция учета профессиональных коэффициентов)
 */
const ProfessionalCategorySection = ({ 
  formData, 
  handleInputChange, 
  errors,
  professionalCategories
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-100 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Award className="w-5 h-5 mr-2 text-purple-500" />
        Профессиональная категория
      </h3>
      
      <div className="mb-4">
        <label htmlFor="professionalCategory" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Выберите категорию профессии
        </label>
        <select
          id="professionalCategory"
          name="professionalCategory"
          value={formData.professionalCategory}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.professionalCategory ? 'input-error' : ''}`}
        >
          {professionalCategories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
        {errors.professionalCategory && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.professionalCategory}
          </p>
        )}
      </div>

      {/* Показываем информацию о выбранной категории */}
      {formData.professionalCategory && formData.professionalCategory !== 'default' && (
        <div className="bg-white dark:bg-gray-800 p-3 rounded-lg border border-purple-100 dark:border-purple-800">
          {(() => {
            const category = professionalCategories.find(c => c.id === formData.professionalCategory);
            if (!category) return null;
            
            return (
              <div className="text-sm">
                <p className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                  {category.name}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
                  <div className="flex items-center">
                    <Award className="w-4 h-4 text-purple-500 mr-2" />
                    <span className="text-xs text-gray-600 dark:text-gray-400">
                      Досрочный выход: <strong>{category.retirementBonus} лет</strong>
                    </span>
                  </div>
                  <div className="flex items-center">
                    <AlertCircle className="w-4 h-4 text-purple-500 mr-2" />
                    <span className="text-xs text-gray-600 dark:text-gray-400">
                      Коэффициент: <strong>×{category.coefficientBonus}</strong>
                    </span>
                  </div>
                </div>
              </div>
            );
          })()}
        </div>
      )}

      <div className="mt-4 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg">
        <div className="flex items-start">
          <Award className="w-5 h-5 text-purple-600 dark:text-purple-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">
              О досрочных пенсиях
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400">
              Работники определенных профессий могут выйти на пенсию раньше общеустановленного возраста. 
              Также для таких категорий могут применяться повышающие коэффициенты при расчете пенсионных баллов. 
              Для подтверждения права на досрочную пенсию необходимо обратиться в территориальное отделение СФР с подтверждающими документами.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalCategorySection;